"use client";

import * as React from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $getRoot } from "lexical";

/**
 * 仅保证根节点下至少有一个子节点（完全空文档时补一个空段落）。
 * 不再在「最后一个块有内容」时自动追加尾部空段；尾部空段由向下键 / 点击编辑区下方空白触发，见 ensureTailEmptyParagraph。
 */
export function TailEmptyParagraphPlugin({ isEditable }: { isEditable: boolean }) {
  const [editor] = useLexicalComposerContext();

  React.useEffect(() => {
    if (!isEditable) return;

    let raf = 0;
    const unregister = editor.registerUpdateListener(() => {
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = 0;
        editor.update(() => {
          const root = $getRoot();
          if (root.getChildren().length === 0) {
            root.append($createParagraphNode());
          }
        });
      });
    });

    return () => {
      if (raf) window.cancelAnimationFrame(raf);
      unregister();
    };
  }, [editor, isEditable]);

  return null;
}
